<div class="form-group-custom">
  <label for="inputGuestsHoliday" class="input-group-zeus__label">Ospiti</label>
  <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
       id="inputGuestsHoliday-dropdown">
    <input type="text"
           (click)="open()"
           autocomplete="off"
           class="form-control-custom"
           id="inputGuestsHoliday"
           [placeholder]="occupancy ? (occupancy | occupancy:occupancy.guests:occupancy.ages) : 'Viaggiatori...'"
           name="viaggiatori"
           aria-label="Viaggiatori"
           aria-describedby="basic-addon3">
    <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
      <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i
        class="g-icon-user"></i></span>
    </div>
  </div>
</div>
